module.exports = __webpack_public_path__ + "media/baojing.0210b0ff.mp3";